import { useQueryClient, useMutation } from '@tanstack/react-query';
import { key as structuralHierachyKey } from "../queries/useStructuralHierachyQuery";
import { key as locationKey } from "../queries/useLocationQuery";
import axios from "axios";
import { useStore } from "../appStore";
import {
    saveToLocalStorage,
    StorageKeys,
} from '../localStorageHelper';


const insertLocation = async (parentId, location) => {

    const response = await axios
        .post(`api/Organization/${parentId}/Locations`, location);
    return response?.data;
}

const useInsertLocationMutation = () => {
    const queryClient = useQueryClient()
    const orgId = useStore((state) => state.CurrentOrganizationId);

    return useMutation({
        mutationFn: async (variables) => await insertLocation(orgId, variables.location),
        onSuccess: (data, variables) => {
            queryClient.setQueryData([structuralHierachyKey], (previousData) => {
                //add the new record to cache
                // ensure we always return a valid array
                const safeData = Array.isArray(previousData) ? previousData : [];
                return [...safeData,
                {
                    accountId: data.accountId,
                    structuralAccountTypeId: data.accountTypeId,
                    name: data.locationName,
                    parentId: data.parentAccountId
                }];
            });
            queryClient.invalidateQueries([locationKey, data.accountId]);
            saveToLocalStorage(StorageKeys.LOCATION(data.accountId), data);
        }
    })
}

export { useInsertLocationMutation };